/* unplugin-vue-components disabled */import { render } from "./welfare_m.vue?vue&type=template&id=9bb4044a"
import script from "./welfare_m.vue?vue&type=script&lang=js"
export * from "./welfare_m.vue?vue&type=script&lang=js"

import "./welfare_m.vue?vue&type=style&index=0&id=9bb4044a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__